
const digest = '770a8d00a7b252f6cb44b9733b5e04d2a1d4a89e819f9f2d1789e7a8156aacb8';
const classes = {"wrapper":"_wrapper_84kap_1","controls":"_controls_84kap_1"};
const css = `._wrapper_84kap_1 ._controls_84kap_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  